var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,21h10v2H5l-1-1V2l1-1h11V3H6V21ZM16.71,6.29l-1.41,1.41,3.29,3.29H9v2h9.59l-3.29,3.29,1.41,1.41,5.29-5.29v-.83l-5.29-5.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignOut);
export default __webpack_public_path__ + "static/1762842647/media/icon-sign-out.523763e22f864cfc1975e0635f2ffd7a.svg";
export { ForwardRef as ReactComponent };